var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-checkbox',{on:{"change":_vm.selectRows},model:{value:(_vm.rowsSelected),callback:function ($$v) {_vm.rowsSelected=$$v},expression:"rowsSelected"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }